firebird
    .directive('fbModal', [
        'templateCache',
        'logService',
        'helperService',
        function (templateCache, logService, helperService) {
            return {
                restrict: 'E', //E for element
                scope: true,
                template: function (element, attr) {
                    var prefix = helperService.getRedesignPathPrefix();
                    const logger = logService.createLoggerWithSource('fbModal');

                    var templates = {
                        recordingOptions: prefix + 'modals/recording-options.html',
                        micWebcamOptions: prefix + 'modals/mic-webcam-options.html',
                        dialInInformation: prefix + 'modals/dial-in-information.html',
                        contentLibrary: prefix + 'modals/contentLibrary.html',
                        webinarOptions: prefix + 'modals/webinar-options.html',
                        pollsModal: prefix + 'modals/polls.html',
                        customBranding: prefix + 'modals/custom-branding.html',
                        webinarPresenterQA: prefix + 'modals/webinar-presenter-qa.html',
                        internationalNumbers: prefix + 'modals/international-numbers.html',
                        chooseAudioOptions: prefix + 'modals/choose-audio-options.html',
                        electronScreen: prefix + 'modals/electron-screen-selection.html',
                        handoutDownloads: prefix + 'modals/handout-downloads.html',
                        meetingSurvey: prefix + 'modals/meeting-survey.html',
                        camaroLeaveSelection: prefix + 'modals/camaro-leave-selection.html',
                        callstatsQualityFeedback: prefix + 'modals/callstatsQualityFeedback.html',
                        virtualAssistantMessage: prefix + 'modals/virtual-assistant.html',
                        waitingRoomHostMessage: prefix + 'modals/waiting-room-host-message.html',
                        createE2EEncryptionKey: prefix + 'modals/create-e2e-encryption-key.html',
                        confirmE2EEncryptionKey: prefix + 'modals/confirm-e2e-encryption-key.html',
                        attendeeWithEchoDetected: prefix + 'modals/attendee-with-echo-detected.html'
                    };

                    if (helperService.getIsRedesign()) {
                        templates.meetingSettings = prefix + 'modals/meetingSettings.html';
                        templates.deviceSelection = prefix + 'modals/device-selection.html';
                    }

                    var templateURL = templates[attr.modalName];
                    if (templateURL) {
                        return templateCache.getTemplate(templateURL);
                    } else {
                        logger.log('Invalid modal template URL');
                        return '';
                    }
                }
            };
        }
    ])

    .directive('modalState', [
        '$window',
        '$timeout',
        '$rootScope',
        'logService',
        'helperService',
        function ($window, $timeout, $rootScope, logService, helperService) {
            const VDIRef = helperService.getVDIRef();
            return {
                restrict: 'A', //A for attribute
                link: function (scope, element, attr, controller) {
                    attr.$observe('modalState', function (newValue) {
                        if (newValue === 'open') {
                            $timeout(() => {
                                if (!VDIRef.showContentsOnTopOfVideo && $window.Janus?.hideVideo) {
                                    // VDI - Hide video streams in meeting when modals are opened.
                                    $window.Janus.hideVideo(true);
                                }
                            }, 300);
                            if (attr.escapable === 'false') {
                                element.modal({ backdrop: 'static', keyboard: false });
                            } else {
                                element.modal('show');
                            }
                        } else if (newValue === 'closed') {
                            element.modal('hide');
                            if (!VDIRef.showContentsOnTopOfVideo && $window.Janus?.hideVideo) {
                                // VDI - Show hidden video streams in meeting when modals are closed.
                                $timeout(() => {
                                    $window.Janus.hideVideo(false);
                                }, 800);
                                $rootScope.$broadcast('vdi-toggle-annotation-ui', false);
                            }
                        }
                    });

                    //Since modals have their own close functionality,
                    //we listen for it here and update controller as needed
                    element.on('hidden.bs.modal', function (e) {
                        //attr.ngController will have the format: "micWebcamOptionsModalCtrl as micWebcamOptions"
                        $rootScope.$broadcast('hide-modal', attr.ngController);
                    });
                }
            };
        }
    ]);
